import script from "./ChangeProjectAccessLevelModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ChangeProjectAccessLevelModal.vue?vue&type=script&lang=ts&setup=true"

import "./ChangeProjectAccessLevelModal.vue?vue&type=style&index=0&id=12666389&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12666389"]])

export default __exports__